import { Round } from './round';
import {Stage} from './stage';

export class Competition {
  id: number;
  competitionName: string;
  competitionType: CompetitionType;
  registrationEnabledFrom: Date;
  registrationEnabledTo: Date;
  competitionStart: Date;
  competitionEnd: Date;
  rounds: Round[];
  authors: number[];

  constructor(
    id = null,
    competitionName = '',
    competitionType = CompetitionType.CEC,
    registrationEnabledFrom = new Date(),
    registrationEnabledTo = new Date(),
    competitionStart = new Date(),
    competitionEnd = new Date(),
    rounds = [],
    authors = []
  ) {
    this.id = id;
    this.competitionName = competitionName;
    this.competitionType = competitionType;
    this.registrationEnabledFrom = registrationEnabledFrom;
    this.registrationEnabledTo = registrationEnabledTo;
    this.competitionStart = competitionStart;
    this.competitionEnd = competitionEnd;
    this.rounds = rounds;
    this.authors = authors;
  }
}

export class CompetitionSimpleDTO {
  id: number;
  competitionName: string;
  authors: number[];
  registrationEnabledFrom: Date;
  registrationEnabledTo: Date;
  competitionStart: Date;
  competitionEnd: Date;

  constructor(
    id = null,
    competitionName = '',
    authors = [],
    registrationEnabledFrom = new Date(),
    registrationEnabledTo = new Date(),
    competitionStart = new Date(),
    competitionEnd = new Date(),
  ) {
    this.id = id;
    this.competitionName = competitionName;
    this.authors = authors;
    this.registrationEnabledFrom = registrationEnabledFrom;
    this.registrationEnabledTo = registrationEnabledTo;
    this.competitionStart = competitionStart;
    this.competitionEnd = competitionEnd;
  }
}

export class CompetitionAdvancedDTO {
  id: number;
  competitionName: string;
  validFrom: Date;
  validTo: Date;
  registrationEnabledFrom: Date;
  registrationEnabledTo: Date;

  constructor(
    id = null,
    competitionName = '',
    validFrom = new Date(),
    validTo = new Date(),
    registrationEnabledFrom = new Date(),
    registrationEnabledTo = new Date()
  ) {
    this.id = id;
    this.competitionName = competitionName;
    this.validFrom = validFrom;
    this.validTo = validTo;
    this.registrationEnabledFrom = registrationEnabledFrom;
    this.registrationEnabledTo = registrationEnabledTo;
  }
}

export class AlreadyRegisteredInCompetition {
  competitionId: number;
  competitionRegistrationId: number;
  serverTime: Date;

  constructor(
    competitionId = null,
    competitionRegistrationId = null,
    serverTime = new Date()
  ) {
    this.competitionId = competitionId;
    this.competitionRegistrationId = competitionRegistrationId;
    this.serverTime = serverTime
  }
}

export enum CompetitionType {
  CEC
}
